import { HiverAxios } from 'h-commons';

import {
    SAVE_USER_DETAILS,
    SAVE_USER_DETAILS_FAIL
} from '../../main/actions/types';

const DASHBOARD_DETAILS = '/account/usage_info';

export function fetchDashboardDetails() {
    return (dispatch) => {
        HiverAxios({
            url: `${DASHBOARD_DETAILS}`,
            type: 'get',
            params: {},
            callback: (response) => {
                const { can_use_csat, businesshour_enabled, sharedLabel_enabled, autoresponse_enabled,
                        featureLimits,
                        sharedMailboxes: totalSharedMailboxes,
                    } = response.data;
                const { smUsers, ugUsers, smNewAutomations, sharedLabels, sharedMailboxes, aliases, sla, businesshour, customFields } = featureLimits;
                const payload = {
                    sharedLabels,
                    sharedMailboxes,
                    smNewAutomations,
                    aliases,
                    businessHourEnabled:businesshour_enabled,
                    sharedLabelEnabled:sharedLabel_enabled,
                    csatEnabled : can_use_csat,
                    smUserLimit: smUsers,
                    ugUserLimit: ugUsers,
                    autoresponseEnabled: autoresponse_enabled,
                    sla: sla,
                    businesshour: businesshour,
                    totalSharedMailboxes,
                    customFields
                }
                dispatch({
                    type: SAVE_USER_DETAILS,
                    payload
                });
            },
            onfail: () => {
                dispatch({
                    type: SAVE_USER_DETAILS_FAIL
                });
            }

        });
    };
}